import { apiRequest } from "./client";

export const searchMembers = (guildId, search = "", limit = 25) =>
  apiRequest(
    `/api/v1/guilds/${guildId}/members?search=${encodeURIComponent(search)}&limit=${limit}`
  );

export const getMember = (guildId, memberId) =>
  apiRequest(`/api/v1/guilds/${guildId}/members/${memberId}`);
